export const FALLBACK_VIEWPORT = {
  height: 1,
  width: 1,
};
